define('views/LoginFormView',[
    'backbone',
    'lodash',
    'models/Form',
    'app',
    'text!templates/login-form.html'
], function (Backbone, _, Form, App, formTmpl) {

    "use strict";

    return Backbone.View.extend({
        
        tagName: 'form',

        template: _.template(formTmpl),

        attributes: {
            method: 'post',
            action: App.siteURL + '/login'
        },

        initialize: function (callbacks) {
            this.callbacks = callbacks;

            // set up form model
            this.model = new Form();
            this.model.url = this.attributes.action;
            this.model.validations = {
                email: ['required', 'email'],
                password: ['required']
            };

            // form template         
            this.el.innerHTML = this.template(App);

            // attach events that change values of inputs
            this.$el
                .find('input, textarea')
                .on('propertychange change click keyup input paste', _.bind(this.onChange, this))
                .on('focusout', _.bind(this.onFocusout, this));
        },

        events: {
            'submit': 'onSubmit'
        },

        /**
         * Storing which input has been touched by the user
         * Equal to true if all inputs have been touched
         * @type {Object}
         */
        touched: {},

        /**
         * onChange event handler to update model and validation errors
         * @param  {jQuery.Event}   event
         */
        onChange: function (event) {
            var input = event.currentTarget;
            if (input.value !== this.model.get(input.name)) {
                this.model.set(input.name, input.value);
                this.model.isValid();
                this.updateValidationWarnings();
            }
        },

        onFocusout: function (event) {
            if (this.touched !== true) {
                var input = event.currentTarget;
                this.touched[input.name] = true;
                this.updateValidationWarnings();
            }
        },

        onSubmit: function (event) {
            this.touched = true;

            // to make sure all form inputs (like form token) are included into the model
            this.updateModel();

            var xhr = this.model.save();

            // callbacks
            if (xhr) {
                this.$el.addClass('requesting');
                xhr.then(
                    _.bind(this.onSubmitSuccess, this),
                    _.bind(this.onSubmitFail, this)
                ).always(
                    _.bind(this.onSubmitComplete, this)
                );
            }

            this.updateValidationWarnings(null, true);
            event.preventDefault();
        },

        onSubmitComplete: function () {
            this.$el.removeClass('requesting');
        },

        onSubmitSuccess: function () {
            this.clear();
            if (this.callbacks.success instanceof Function) {
                this.callbacks.success.apply(this, arguments);
            }
        },

        onSubmitFail: function (xhr) {
            // validation fail in server
            // TODO: cache invalid values if we have validations that can only be done in server, 
            //       such as unique email address in database
            if (xhr.status === 400) {
                this.updateValidationWarnings(xhr.responseJSON, true);
            }
            // submit form without ajax for other errors
            else {
                this.el.submit();
            }
        },

        updateModel: function () {
            var attrs = [];
            _.each(this.$el.serializeArray(), function (input) {
                attrs[input.name] = input.value;
            });
            this.model.set(attrs);
        },

        clear: function () {
            this.$el.find('input:not([type="hidden"]), textarea').val('');
            this.updateModel();
        },

        updateValidationWarnings: function (errors, submitted) {
            if (!errors) {
                errors = this.model.validationError || {};
            }

            this.$el.find('.help-block').each(_.bind(function (i ,el) {
                var name = el.getAttribute('data-for'),
                    err = errors[name] || '';

                // to not annoying users with error msg when filling in inputs at the first time,
                // only update error msg to touched inputs
                if (!(this.touched === true || this.touched[name])) {
                    return true;
                }

                // for laravel, error messages are sent in array
                if (err instanceof Array) {
                    err = err[0];
                }

                // update error message...
                el.innerHTML = err;

                // ...and error class for the form-group parent
                var $parent = $(el).parents('.form-group');
                if (err) {
                    $parent.addClass('has-error');
                } else {
                    $parent.removeClass('has-error');
                }
            }, this));

            // invalid class for the form element
            if (_.size(errors) && submitted) {
                this.$el.addClass('invalid');
            } else {
                this.$el.removeClass('invalid');
            }
        }

    });

});
